import { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { TFunction } from 'i18next';
import { useAppSelector } from '../stores';
import {
    buildInterviewRailNotificationMessages,
    type NotificationMessage,
} from '../components/notifications/ScrollingNotification';
import { getInterviewRailNotifications } from '../services/api/appContentService';

/**
 * Cartes d’annonce (rail droit) : contenu backoffice (faml-api) si configuré, sinon i18n.
 */
export function useInterviewRailMessages(): NotificationMessage[] {
    const { t, i18n } = useTranslation();
    const accessToken = useAppSelector((s) => s.auth.access_token);

    const fallback = useMemo(
        () => buildInterviewRailNotificationMessages(t as TFunction),
        [t, i18n.language]
    );

    const [messages, setMessages] = useState<NotificationMessage[]>(fallback);

    useEffect(() => {
        let cancelled = false;
        setMessages(buildInterviewRailNotificationMessages(t as TFunction));
        void (async () => {
            try {
                const data = await getInterviewRailNotifications(
                    i18n.language,
                    accessToken
                );
                if (cancelled) return;
                if (data?.configured && data.messages && data.messages.length > 0) {
                    setMessages(data.messages);
                }
            } catch {
                /* keep messages from setMessages above */
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [i18n.language, accessToken, t]);

    return messages;
}
